import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BASE}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

export const streamChat = async (message, onDelta) => {
    const res = await fetch(`${API_BASE}/chat`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ message }),
    });
    if (!res.ok || !res.body) throw new Error("Chat failed");
    const reader = res.body.getReader();
    const dec = new TextDecoder();
    while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        onDelta(dec.decode(value, { stream: true }));
    }
};
